import { Image, SvgIcon } from 'components/icons'
import { Text, TextSize, Weight } from 'components/typography'
import React from 'react'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

interface TitleProps {
  active: boolean
  pointed?: boolean
  width?: string
}

export const SelectWrapper = styled.div<TitleProps>`
  position: relative;
  width: ${(props) => (props.width ? props.width : '100%')};
  transition: width 0.4s ease-out -0.2s;
  display: flex;
  background-color: ${GLOBAL_COLORS.transparent};
`

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  gap: 5px;
`

export const StyledTitle = styled.button<TitleProps>`
  border: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.primaryFontColor};
  background-color: ${({ theme }) => theme.widgetBgColor};
  cursor: ${({ pointed }) => pointed && 'pointer'};
  & span {
    margin-right: 5px;
    color: ${({ theme }) => theme.primaryFontColor};
    font-weight: ${Weight.SemiBold};
  }
`

export const ScrollList = styled.div<React.HTMLProps<HTMLDivElement>>`
  position: absolute;
  left: -20px;
  top: -92px;
  height: 317px;
  width: 280px;
  border-radius: 20px;
  border-top: none;
  z-index: 1;
  overflow-y: auto;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.widgetBgColor};
`

export const ScrollTitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
`

export const StyledCloseButton = styled(SvgIcon)`
  cursor: pointer;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  &:hover {
    background-color: ${({ theme }) => theme.activeItemColor};
  }
`

export const ListItem = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => (theme.darkMode ? GLOBAL_COLORS.switchGrey : theme.bg)};
  border: none;
  width: fill-available;
  height: 46px;
  cursor: pointer;
  transition: 0.2s ease-out;
  padding: 0 10px;
  margin: 0 20px;
  border-radius: 10px;
  &:hover {
    background-color: ${({ theme }) => (theme.darkMode ? `#414141` : GLOBAL_COLORS.switchBlue)};
  }
`

export const CoinIcon = styled(Image)`
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`

export const ItemContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`

export const SelectorText = styled(Text)`
  color: ${({ theme }) => theme.secondaryFontColor};
  font-weight: ${Weight.Bold};
`

export const SelectItemText = styled(Text)`
  font-size: ${TextSize.two};
  color: ${({ theme }) => theme.secondaryFontColor};
  font-weight: ${Weight.Bold};
`

export const SelectItemSubText = styled(Text)`
  font-size: ${TextSize.small};
  color: ${GLOBAL_COLORS.investCurrencyGrey};
  font-weight: ${Weight.Medium};
  display: inline-flex;
  align-self: flex-end;
  margin-bottom: 3px;
`

export const SelectArrow = styled.span<{ size: number }>`
  display: flex;
  height: ${(props) => props.size + 'px'};
  width: ${(props) => props.size + 'px'};
  border-bottom: 2px solid ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
  border-right: 2px solid ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
  transition: 0.2s ease-out;
  margin-left: 7px;
  transform: rotate(45deg);
  margin-bottom: 3px;
`
